// Friendly copy + presentation for the raw OAuth scope strings the MCP
// consent page receives via the `scope` query param (space-separated, e.g.
// "mcp:read mcp:write mcp:send"). The backend doesn't care how these are
// presented, only which raw scope strings are submitted back — see
// OAuthConsent.tsx. Mirrors Mailzzy's own SCOPE_COPY (ss-mailzzy-web
// OAuthConsent.tsx), reworded for Inkfree's document/sign-request domain.
export type ScopeIconKind = "write" | "send" | "read" | "identity";

export interface ScopeCopy {
  label: string;
  detail: string;
  icon: ScopeIconKind;
}

const SCOPE_COPY: Record<string, ScopeCopy> = {
  "mcp:write": {
    label: "Create and update your documents",
    detail: "Add or edit sign requests, templates and folders.",
    icon: "write",
  },
  "mcp:send": {
    label: "Send on your behalf",
    detail: "Send and void sign requests from your account.",
    icon: "send",
  },
  "mcp:read": {
    label: "View your Inkfree data",
    detail: "Read sign requests, templates, folders and reports.",
    icon: "read",
  },
  openid: {
    label: "Confirm your identity",
    detail: "Share the email address you're signed in with.",
    icon: "identity",
  },
};

export const describeScope = (scope: string): ScopeCopy =>
  SCOPE_COPY[scope] ?? { label: scope, detail: "Requested permission.", icon: "identity" };

export const parseScopes = (rawScope: string | null): string[] =>
  (rawScope ?? "").split(/\s+/).filter(Boolean);
